import { createFilter } from 'react-select';
import SearchableSelect from './SearchableSelect';

const filterTimezone = createFilter({
 stringify: option => `${option.label} ${option.value.replace(/_/g, ' ')}`,
});

export default function TimezoneSelect({ options, value, onChange }) {
 return <SearchableSelect label="Timezone" options={options.map(zone => ({ value: zone, label: zone }))}
  value={value} onChange={onChange} placeholder="Search timezones…"
  emptyMessage="No matching timezones" filterOption={filterTimezone} />;
}
